import { z } from "zod";
export const serverResponse = z.record(z.string().or(z.object({}))).and(
  z.object({
    defaultPayment: z.string(),
    defaultRefund: z.string(),
    icon: z.record(z.string()).and(
      z.object({
        defaultPayment: z.string(),
        defaultRefund: z.string(),
      }),
    ),
  }),
);
